import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router";

import { EPlatform, ERequestState, RequestDto, TempRSHRequestApi, TempRSHRequestDto } from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume, DrupalStepper } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { DrupalTempRshForm } from "./DrupalTempRshForm";

export interface IDrupalTempRshRequestPageProps {}

export const DrupalTempRshRequestPage: React.FunctionComponent<IDrupalTempRshRequestPageProps> = () => {
  const { id } = useParams<{ id: string }>();
  const temprshRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(TempRSHRequestApi);

  const [currentStep, setCurrentStep] = React.useState(0);

  const { data, loading, saveItem, saving } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: (apiId = temprshRequestId) =>
          apiId > 0
            ? api.get(apiId)
            : new TempRSHRequestDto({
                request: new RequestDto({
                  requestDate: new Date(),
                  status: ERequestState.REQUESTED,
                  platform: EPlatform.PORTAL,
                }),
              }).toJSON(),
        saveApiFn: (d: TempRSHRequestDto) => api.save(TempRSHRequestDto.fromJS({ ...d, isPortal: true })),
        onSavedRoute: (d: TempRSHRequestDto) =>
          d.request.status === ERequestState.BILLED
            ? `${EDrupalRoutes.tempRshRequest}/${d.dogTempOwnershipChangeRequestId}`
            : EDrupalRoutes.membershipRequest,
        deleteApiFn: () => {},
      }),
      [api, temprshRequestId]
    ),
    [temprshRequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet
        title={
          currentStep === 2
            ? `${t(ETLCodes.Payment)}: ${t(ETLCodes.TempRSHRequest)}`
            : `${t(ETLCodes.NewRequest)}: ${t(ETLCodes.TempRSHRequest)}`
        }
      >
        {data?.dogTempOwnershipChangeRequestId < 0 || data?.request?.status === ERequestState.REQUESTED ? (
          <DrupalStepper stepNumber={currentStep} />
        ) : null}
        <div>
          {data?.request?.status === ERequestState.REQUESTED ? (
            <DrupalTempRshForm
              tempRshRequestId={temprshRequestId}
              stepNumber={currentStep}
              initialdata={data}
              loading={saving}
              onStepChange={(newStep) => setCurrentStep(newStep)}
              save={(formikdata) => saveItem(formikdata)}
            />
          ) : saving ? (
            <Spinner />
          ) : (
            <DrupalRequestResume
              requestForm={
                <DrupalTempRshForm
                  showStepper={data?.request?.status !== ERequestState.BILLED}
                  tempRshRequestId={temprshRequestId}
                  stepNumber={currentStep}
                  initialdata={data}
                  loading={saving}
                  onStepChange={(newStep) => setCurrentStep(newStep)}
                  save={(formikdata) => saveItem(formikdata)}
                />
              }
              requestDto={data?.request}
              bill={null}
            />
          )}
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
